package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.allergens_tab

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.GetProduct
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.checked_ingredients_list.CheckedIngredient
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.ingeredient_list.Ingredients
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.allergens_tab.component.AddingCustomAllergene
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.allergens_tab.component.AlergensTable
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection

@Composable
fun Allergens(
    selectedProduct: GetProduct?,
    showAddNewAlergeneComponent:Boolean,
    windowSizeMode: WindowSizeModeEnum,
    updateAllergenData: (Boolean,String) -> Unit,
    ingredients: List<Ingredients>?,
    checkedIngredients: List<CheckedIngredient?>?,
    onSearchValueChange: (String) -> Unit,
    getIngredients: () -> Unit,
    getCheckedIngredients: () -> Unit,
    showCustomAllergenDialogStatus:(Boolean)->Unit,
    setCreateAllergenComponentStatus:(Boolean)->Unit,
)
{
    LaunchedEffect(Unit){
        getIngredients()
    }
    LaunchedEffect(selectedProduct?.id){
        getCheckedIngredients()
    }

    Column(
        Modifier
            .fillMaxWidth()
            .fillMaxHeight()
            .styleModifier {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
            }
            .padding(
               bottom =  Dimen.extraLargePadding,
               top = Dimen.largePadding,
               leftRight = Dimen.extraLargePadding
            )
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
        , horizontalAlignment = Alignment.Start
    )
    {
        MediumContentTitle(
            title = Strings.current().setting
        )

        Row(
            modifier = Modifier
                .thenIf(
                    windowSizeMode!=WindowSizeModeEnum.Desktop,
                    Modifier.fillMaxWidth()
                )
//                .autoResponsiveness()
                .weight(1f)
        )
        {
            AlergensTable(
                windowSizeMode = windowSizeMode,
                ingredients = ingredients,
                checkedIngredients = checkedIngredients,
                onSearchValueChange = {
                    onSearchValueChange(it)
                },
                updateAllergenData = { contains, ingredientId ->
                    updateAllergenData(contains, ingredientId)
                },
                onAddAlergenClick = {
                    setCreateAllergenComponentStatus(true)
                }
            )

            if (showAddNewAlergeneComponent &&
                windowSizeMode==WindowSizeModeEnum.Desktop){
                AddingCustomAllergene(
                    modifier = Modifier,
                    title = Strings.current().addNewAlergene,
                    windowSizeMode=windowSizeMode,
                    ingredients = ingredients,
                    checkedIngredients=checkedIngredients,
                    showCustomAllergeneDialog={
                        showCustomAllergenDialogStatus(true)
                    },
                    onCancelClick={
                        setCreateAllergenComponentStatus(false)
                    },
                    updateAllergenData = { contains, ingredientId ->
                        updateAllergenData(contains, ingredientId)
                    }
                )
            }


        }







    }
}





